<template>
  <div>
    <v-app-bar flat app class="white">
      <v-app-bar-nav-icon
        color="red"
        class="hidden-md-and-up"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>

      <v-img
        alt="Raging Pixel Studios Logo"
        contain
        src="@/assets/Logos/Logo_side.png"
        height="56"
        width="248"
      />

      <v-spacer class="hidden-sm-and-down"></v-spacer>

      <v-tabs
        class="hidden-sm-and-down"
        centered
        light
        color="red"
        slider-color="red"
      >
        <v-tab v-for="tab in tabs" :key="tab.text" router :to="tab.route">
          <span class="font-weight-bold px-5">{{ tab.text }}</span>
        </v-tab>
      </v-tabs>

      <v-btn
        v-for="social in socials"
        :key="social.icon"
        :color="social.color"
        class="d-none mx-2 white--text"
        fab
        depressed
        x-small
      >
        <v-icon>{{ social.icon }}</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer app light temporary v-model="drawer">
      <v-img
        alt="Raging Pixel Studios Logo"
        contain
        src="@/assets/Logos/Logo_side.png"
        width="248"
        class="mx-auto my-3"
      />
      <v-divider></v-divider>
      <v-list nav>
        <v-list-item-group color="red">
          <v-list-item
            v-for="tab in tabs"
            :key="tab.title"
            link
            router
            :to="tab.route"
          >
            <v-list-item-icon>
              <v-icon class="red--text">{{ tab.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ tab.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: "Navbar",

  data: () => ({
    drawer: false,
    tabs: [
      { text: "Home", icon: "mdi-home", route: "/" },
      { text: "Games", icon: "mdi-gamepad-variant", route: "/games" },
      { text: "About Us", icon: "mdi-information", route: "/about" }
    ],
    socials: [
      {
        icon: "mdi-twitter",
        color: "#00acee"
      },
      {
        icon: "mdi-discord",
        color: "#738ADB"
      },
      {
        icon: "mdi-youtube",
        color: "#FF0000"
      }
    ]
  })
};
</script>
